var map = {
	"./alert-sign.svg": 121,
	"./arrow-down-circle.svg": 135,
	"./arrow-input-grey.svg": 136,
	"./arrow-input-white.svg": 137,
	"./arrow-right-blue.svg": 45,
	"./arrow-right-green.svg": 71,
	"./arrow-right-grey.svg": 69,
	"./arrow-right-orange.svg": 79,
	"./arrow-right.svg": 127,
	"./authorize.svg": 138,
	"./back-arrow.svg": 107,
	"./calendar-arrow-back-double.svg": 46,
	"./calendar-arrow-back.svg": 47,
	"./campaign-pause.svg": 117,
	"./campaign-play.svg": 118,
	"./campaign-stop.svg": 119,
	"./checkbox-content.svg": 78,
	"./checkmark-done-circle.svg": 228,
	"./clip-blue.svg": 229,
	"./clip-grey.svg": 128,
	"./clock.svg": 230,
	"./copy-white.svg": 120,
	"./copy.svg": 124,
	"./cross-grey.svg": 231,
	"./cross.svg": 66,
	"./dashboard-api.svg": 139,
	"./dashboard-create.svg": 140,
	"./dashboard-faq.svg": 141,
	"./dashboard-send.svg": 142,
	"./dashboard-templates.svg": 143,
	"./double-check.svg": 144,
	"./download.svg": 129,
	"./drag-and-drop-image.svg": 145,
	"./dropdown-arrow.svg": 130,
	"./edit-file.svg": 146,
	"./edit.svg": 122,
	"./empty-avatar.svg": 125,
	"./envelope-b.svg": 232,
	"./envelope-w.svg": 233,
	"./external-link.svg": 131,
	"./eye-clear.svg": 68,
	"./eye-off.svg": 76,
	"./eye-on.svg": 77,
	"./header-navbar-item-corner.svg": 147,
	"./help-circle.svg": 113,
	"./mail-grey.svg": 148,
	"./menu-01-address-book-b.svg": 234,
	"./menu-01-address-book-w.svg": 235,
	"./menu-02-campaign-b.svg": 236,
	"./menu-02-campaign-w.svg": 237,
	"./menu-03-statistics-b.svg": 238,
	"./menu-03-statistics-w.svg": 239,
	"./menu-04-pricing-b.svg": 240,
	"./menu-04-pricing-w.svg": 241,
	"./menu-05-api-b.svg": 242,
	"./menu-05-api-w.svg": 243,
	"./menu-06-more-b.svg": 244,
	"./menu-06-more-w.svg": 245,
	"./menu-07-sender-ids-b.svg": 246,
	"./menu-07-sender-ids-w.svg": 247,
	"./menu-right.svg": 149,
	"./more.svg": 110,
	"./navbar-api-dark.svg": 150,
	"./navbar-api-orange.svg": 151,
	"./navbar-approved-templates-dark.svg": 152,
	"./navbar-approved-templates-orange.svg": 153,
	"./navbar-balance-dark.svg": 154,
	"./navbar-balance-orange.svg": 155,
	"./navbar-barred-list-dark.svg": 156,
	"./navbar-barred-list-orange.svg": 157,
	"./navbar-company-dark.svg": 158,
	"./navbar-company-orange.svg": 159,
	"./navbar-detailed-dark.svg": 160,
	"./navbar-detailed-orange.svg": 161,
	"./navbar-faq-dark.svg": 162,
	"./navbar-faq-orange.svg": 163,
	"./navbar-hlr-dark.svg": 164,
	"./navbar-hlr-orange.svg": 165,
	"./navbar-incoming-messages-dark.svg": 166,
	"./navbar-incoming-messages-orange.svg": 167,
	"./navbar-invoices-dark.svg": 168,
	"./navbar-invoices-orange.svg": 169,
	"./navbar-logs-dark.svg": 170,
	"./navbar-logs-orange.svg": 171,
	"./navbar-managers-dark.svg": 172,
	"./navbar-managers-orange.svg": 173,
	"./navbar-moderation-dark.svg": 174,
	"./navbar-moderation-orange.svg": 175,
	"./navbar-my-account-dark.svg": 176,
	"./navbar-my-account-orange.svg": 177,
	"./navbar-password-dark.svg": 178,
	"./navbar-password-orange.svg": 179,
	"./navbar-payment-pending-dark.svg": 180,
	"./navbar-payment-pending-orange.svg": 181,
	"./navbar-pricing-dark.svg": 182,
	"./navbar-pricing-orange.svg": 183,
	"./navbar-regular-dark.svg": 184,
	"./navbar-regular-orange.svg": 185,
	"./navbar-reports-dark.svg": 186,
	"./navbar-reports-orange.svg": 187,
	"./navbar-rules-dark.svg": 188,
	"./navbar-rules-orange.svg": 189,
	"./navbar-scheduled-dark.svg": 190,
	"./navbar-scheduled-orange.svg": 191,
	"./navbar-sender-dark.svg": 192,
	"./navbar-sender-orange.svg": 193,
	"./navbar-sent-dark.svg": 194,
	"./navbar-sent-orange.svg": 195,
	"./navbar-services-dark.svg": 196,
	"./navbar-services-orange.svg": 197,
	"./navbar-shorten-link-dark.svg": 198,
	"./navbar-shorten-link-orange.svg": 199,
	"./navbar-statistics-hlr-dark.svg": 200,
	"./navbar-statistics-hlr-orange.svg": 201,
	"./navbar-subscribers-dark.svg": 202,
	"./navbar-subscribers-orange.svg": 203,
	"./navbar-summary-dark.svg": 204,
	"./navbar-summary-orange.svg": 205,
	"./navbar-templates-dark.svg": 206,
	"./navbar-templates-orange.svg": 207,
	"./navbar-two-factor-authentication-dark.svg": 208,
	"./navbar-two-factor-authentication-orange.svg": 209,
	"./navbar-visit-history-dark.svg": 210,
	"./navbar-visit-history-orange.svg": 211,
	"./navbar-white-list-dark.svg": 212,
	"./navbar-white-list-orange.svg": 213,
	"./options.svg": 248,
	"./password.svg": 214,
	"./plus-circle.svg": 249,
	"./plus-in-circle.svg": 123,
	"./pop-up-cross.svg": 72,
	"./radio-content.svg": 250,
	"./redirect.svg": 251,
	"./refresh.svg": 132,
	"./rounded-polygon.svg": 126,
	"./search-blue.svg": 215,
	"./search-white.svg": 216,
	"./search.svg": 252,
	"./select-dropdown-arrow.svg": 75,
	"./selected-option-marker.svg": 253,
	"./send-white.svg": 217,
	"./sliders.svg": 254,
	"./social-media-facebook.svg": 218,
	"./social-media-linkedin.svg": 219,
	"./social-media-twitter.svg": 220,
	"./social-media-whats-app.svg": 221,
	"./sort-down.svg": 222,
	"./sort-up.svg": 223,
	"./steps-check.svg": 112,
	"./support-clock-icon.svg": 224,
	"./support-mail-icon.svg": 225,
	"./support-phone-icon.svg": 226,
	"./toggle-notifications-b.svg": 255,
	"./toggle-notifications-w.svg": 256,
	"./toggle-profile-b.svg": 257,
	"./toggle-sliders-b.svg": 258,
	"./toggle-sliders-w.svg": 259,
	"./toggle-support-b.svg": 260,
	"./toggle-support-w.svg": 261,
	"./trash.svg": 111,
	"./ui-status-error.svg": 80,
	"./ui-status-success.svg": 73,
	"./uploading-cloud.svg": 114,
	"./user-plus-dark.svg": 262,
	"./user-plus.svg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;